<template>
	<div class="channels">
		<ul class="list-unstyled">
			<li v-for="(channel, index) in channels" class="channel" v-bind:key="index">
				<img :src="channel.web_logo" alt="" class="channel__logo">
				<span class="channel__title">{{channel.seo_title}}</span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {

		name: 'vtv-channels',

		data () {
			return {
				channels: [],
			}
		},
		methods: {
			load() {
				window.api._.request('get', 'https://www.vtvgiaitri.vn/api/v1/channel')
				.then(res => this.channels = res.data);
			}
		},
		created() {
			this.load();
		}
	}
</script>

<style lang="css" scoped>
</style>